'use client';

import { useEffect } from 'react';
import { useNotificationManager } from 'hooks/useNotificationManager';
import { useAuthStore } from 'stores/authStore';

export default function NotificationProvider({ children }: { children: React.ReactNode }) {
  const { currentUser } = useAuthStore();
  const notificationManager = useNotificationManager();

  useEffect(() => {
    // Notification manager will auto-initialize when user is logged in
    // through its own useEffect hook
  }, [currentUser]);

  return <>{children}</>;
}